module.exports = __webpack_public_path__ + "static/media/slides-action-plan.09e0e979.svg";